import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { MainSpinner, Page } from "../../components";
import { useViewModel } from "../../hooks/useViewModel";
import { templateEnum } from "../templateEnum";
import ServerError from "../../components/ServerError";
import NotFound from "../../components/NotFound";

const getBrowsePath = (type, slug) => {
  return type ? `${type}/${slug}` : slug;
};

// The purpose of the Base Template is to request the viewmodel and determine which template to use.
// When using this template, be sure to provide route params "type (if available)" and "slug" in the routes file.
const BaseTemplate = ({ getPath = getBrowsePath }) => {
  const { type, slug } = useParams();
  const { search } = useLocation();
  const browsePath = getPath(type, slug, search);
  const [viewModel, isLoading, hasError, statusCode] = useViewModel(browsePath);

  // determine which template to use for the browse page
  const { template } = viewModel || {};
  const Template = templateEnum[template];

  if (isLoading) {
    return <MainSpinner />;
  }

  if (hasError) return statusCode === 404 ? <NotFound /> : <ServerError />;

  return (
    <Page>
      {Template && <Template {...viewModel} browsePath={browsePath} />}
    </Page>
  );
};

export default BaseTemplate;
